/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
import 'flickity-imagesloaded';

export function imageCarousel() {
  var carousels = document.querySelectorAll('.image-carousel__track');
  if (!carousels.length) return;

  carousels.forEach(function(track) {
    new Flickity(track, {
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      groupCells: false,
      autoPlay: 4000,
      pauseAutoPlayOnHover: true,
      adaptiveHeight: false,
      percentPosition: true,
      imagesLoaded: true,
      cellSelector: '.carousel-cell'
    });
  });
}

